import { FC, ReactNode } from "react";
import { formatNumber } from "src/utility";
import classNames from "classnames";

export type SelectionItemData = {
  label: ReactNode;
  price: number;
  currency: string;
};

type SelectionItemProps = SelectionItemData & { selected: boolean };

const SelectionItem: FC<SelectionItemProps> = ({ label, price, currency, selected }) => {
  return (
    <div
      className={classNames(
        "border-border-default bg-background-default hover:border-border-active flex h-full w-full min-w-min cursor-pointer flex-col justify-between gap-5 rounded-lg border p-4 transition-colors duration-200",
        selected && "bg-primary-20! border-border-active!",
      )}
    >
      <div className="text-font-default flex items-center justify-between gap-3 text-base font-medium">
        <span>{label}</span>
        <span
          className={classNames(
            "outline-border-default flex size-2 shrink-0 items-center justify-center rounded-full outline",
            selected && "outline-border-active! bg-background-default outline-4!",
          )}
        />
      </div>
      <div className="flex flex-col items-center justify-between gap-2 md:flex-row">
        <div className={classNames("text-14 text-font-default flex w-full flex-1 gap-1 font-bold tracking-wide", selected && "text-font-active!")}>
          <span>{`${formatNumber(price)} ${currency}`}</span>
        </div>
      </div>
    </div>
  );
};

export default SelectionItem;
